import Layout from '@/layout/index.vue';
import { transportersSubMenu } from './subMenus/transporter-sub-menu';
const orderRouter = {
  path: '/order',
  component: Layout,
  redirect: 'noredirect',
  name: 'orderManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Invoice Manager', 'Sales Manager', 'Order Manager'],
    title: 'orderManagement.title',
    icon: 'shopping'
  },
  children: [{
    path: '/order/list',
    component: () => import('@/views/order/list.vue'),
    name: 'Orders',
    meta: {
      roles: ['Super Admin', 'Admin', 'Unit Manager', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Invoice Manager', 'Sales Manager', 'Order Manager'],
      title: 'orderManagement.orders.title',
      icon: 'shopping',
      noCache: true
    }
  }, {
    path: '/order/pending-dispatch',
    component: () => import('@/views/order/pending-dispatch.vue'),
    name: 'Pending Dispatch',
    meta: {
      title: 'orderManagement.orders.dispatch',
      icon: 'shopping',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/orders/pending-list',
    component: () => import('@/views/orders-dispatches/pending-orders-products.vue'),
    name: 'inventoryManagement.dispatch.pendingOrder',
    meta: {
      title: 'inventoryManagement.dispatch.pendingOrder',
      roles: ['Super Admin', 'Admin', 'Unit Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Agent', 'Branch Manager'],
      noCache: true,
      hidden: false,
      icon: 'scale'
    }
  }, {
    path: '/order/edit/:id(.*)',
    component: () => import('@/views/order/manage.vue'),
    name: 'orderManagement.orders.edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'orderManagement.orders.edit',
      roles: ['Super Admin', 'Admin', 'Unit Manager', 'Order Manager'],
      noCache: true,
      activeMenu: '/order/list',
      hidden: true
    }
  }, {
    path: '/order/ratings/:id(.*)',
    component: () => import('@/views/order/ratings.vue'),
    name: 'orderManagement.orders.manageRating',
    meta: {
      title: 'orderManagement.orders.manageRating',
      roles: ['Super Admin', 'Admin', 'Order Manager'],
      noCache: true,
      activeMenu: '/order/list',
      hidden: true
    }
  }, {
    path: '/order/modify/:id(.*)',
    component: () => import('@/views/order/manage-order.vue'),
    name: 'orderManagement.orders.manage',
    props: {
      isEdit: true
    },
    meta: {
      title: 'orderManagement.orders.manage',
      roles: ['Super Admin', 'Admin', 'Unit Manager', 'Agent', 'Branch Manager', 'Order Manager'],
      noCache: true,
      activeMenu: '/order/list',
      hidden: true
    }
  }, {
    path: '/order/:id(.*)',
    component: () => import('@/views/order/components/OrderInfoDetails.vue'),
    name: 'orderManagement.orders.info',
    props: {
      isEdit: true
    },
    meta: {
      title: 'orderManagement.orders.info',
      noCache: true,
      activeMenu: '/order/list',
      hidden: true
    }
  }, {
    path: '/order/add',
    component: () => import('@/views/order/manage.vue'),
    name: 'orderManagement.orders.add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'orderManagement.orders.add',
      roles: ['Super Admin', 'Order Manager'],
      noCache: true,
      activeMenu: '/order/list',
      hidden: true
    }
  },
  // ...transactionsSubMenu,
  ...transportersSubMenu
  // ...ledgersSubMenu
  // ...ordersTicketsSubMenu,
  // ...couponsSubMenu
  ]
};
export default orderRouter;